/**
 * Returns `true` when Hub corner radius customization should be active.
 *
 * Corner radius is a sub-feature of advanced theming and never ships without
 * it, so this follows `useIsAdvancedThemingEnabled` (the product-level flag
 * `advanced-theming-in-hub` via HubContext, plus the platform gate).
 *
 * Cross-host safe: returns `false` when HubContext is not mounted
 * (Confluence Company Hub, CSM, etc.) because `useIsAdvancedThemingEnabled`
 * returns false in that case.
 */
import { useIsAdvancedThemingEnabled } from '../use-is-advanced-theming-enabled';

export const useIsHubCornerRadiusEnabled = (): boolean => useIsAdvancedThemingEnabled();
